module.exports = __webpack_public_path__ + "img/copy.a746a86e.svg";